'use client';

import { useState } from 'react';

import RichText from '@/components/ui/RichText/RichText';

import ArticleCard from './ArticleCard';
import type { Article, ArticleRichText } from './types';

const INITIAL_COUNT = 3;

export default function RelatedArticles({
  articles,
  heading,
  routePrefix,
}: {
  articles: Article[];
  heading: ArticleRichText;
  routePrefix: string;
}) {
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);

  if (!articles.length) return null;

  const visibleArticles = articles.slice(0, visibleCount);
  const hasMore = visibleCount < articles.length;

  return (
    <section className="my-6 bg-transparent">
      <div className="content-wrapper">
        <RichText styles={heading.styles}>{heading.content}</RichText>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {visibleArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              article={article}
              href={`${routePrefix}/${article.slug}`}
              showTopics
            />
          ))}
        </div>

        <div className="mt-8 flex justify-center gap-4">
          {hasMore && (
            <button
              onClick={() => setVisibleCount((previous) => previous + 6)}
              className="border-info-500-soft text-text-action-teal hover:bg-info-500-soft flex cursor-pointer items-center gap-2 rounded-lg border px-4 py-2.5 text-base font-bold transition"
            >
              View More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="h-4 w-4"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
